<template>
  <div class="invalid-token">
    <div class="row text-center">
      <div class="col-12">
        <h2>Invalid Token</h2>
      </div>
      <div class="col-12 text-center">
        <p>We are sorry, but your provided token is invalid.</p>
      </div>
      <div class="col text-center">
        <p>
          To generate a new token visit our
          <a href="https://vivid-leaf.net/settings/applications" target="_blank"> API Application Page. </a>
        </p>
      </div>
    </div>
    <div class="row"></div>
    <div class="row"></div>
    <div class="row"></div>
    <div class="row"></div>
    <div class="row">
      <div class="col text-center">
        <h5>Powered by <a href="https://vivid-leaf.net" target="_blank" class="website">Vivid Leaf.</a></h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvalidToken',
};
</script>

<style scoped>
.invalid-token {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
